var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHello(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/icon_hello") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/icon_hello",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    fill: "#0078D7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.143,27.7998 C6.543,27.7998 0.643,19.2998 0.343,18.9008 C-0.257,17.9998 -0.057,16.4998 0.843,15.9008 C1.743,15.2998 3.043,15.1998 3.643,16.0998 C3.743,16.1998 8.743,23.1998 16.143,23.1998 C23.543,23.1998 28.543,16.0998 28.643,16.0998 C29.243,15.1998 30.543,15.2998 31.443,15.9008 C32.343,16.4998 32.543,17.9998 31.943,18.9008 C31.643,19.2998 25.743,27.7998 16.143,27.7998",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5429,0.5 C9.7519,0.5 11.5429,2.291 11.5429,4.5 C11.5429,6.709 9.7519,8.5 7.5429,8.5 C5.3339,8.5 3.5429,6.709 3.5429,4.5 C3.5429,2.291 5.3339,0.5 7.5429,0.5",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7426,0.5 C26.9526,0.5 28.7426,2.291 28.7426,4.5 C28.7426,6.709 26.9526,8.5 24.7426,8.5 C22.5336,8.5 20.7426,6.709 20.7426,4.5 C20.7426,2.291 22.5336,0.5 24.7426,0.5",
    id: "Fill-5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHello);
export default __webpack_public_path__ + "static/media/icon_hello.3c7f248a43dfe2928dd1d1831be98041.svg";
export { ForwardRef as ReactComponent };